import { useFormContext } from 'react-hook-form'
import { Radio } from '../../shared/compass-ui'

export default function AccountsRadioInput() {
  const {
    formState: { errors },
    watch,
  } = useFormContext()
  const { accounts: accountsError } = errors

  const selectedValue = watch('accounts')
  const hasError = typeof accountsError?.message === 'string'
  const options = [
    {
      label: 'Checking and Savings',
      value: 'both',
    },
    {
      label: 'Checking Only',
      value: 'checking',
    },
    {
      label: 'Savings Only',
      value: 'savings',
    },
    {
      label: 'Neither',
      value: 'neither',
    },
  ]

  return (
    <div
      id="accounts-radio-inputs-group"
      className={`bg-white flex flex-col rounded-md ${
        hasError ? 'border-red-600 border-2 outline-red-600 focus:border-red-600' : ''
      }`}
    >
      {options.map((option, idx) => (
        <Radio
          key={`radio-option-${option.value}`}
          {...option}
          hasError={hasError}
          selectedValue={selectedValue}
          name="accounts"
          idx={idx}
        />
      ))}
    </div>
  )
}
